import {Injectable, OnInit, EventEmitter} from "@angular/core";
import {User} from "../../+admin/+users/users.service";
import {isNullOrUndefined} from "util";


Injectable();

export class UtilityService {

    private _hideFooter: boolean = true;
    private _hideRibbon: boolean = true;
    public toggleSidebar: EventEmitter<any> = new EventEmitter();
    public returnImage: any = null;
    public genericFlag: boolean = false;

    constructor() {
    }

    get hideFooter(): boolean {
        return this._hideFooter;
    }
    set hideFooter(hide: boolean) {
        if (hide != this._hideFooter) {
            setTimeout(() => this._hideFooter = hide, 100);
        }
    }

    get hideRibbon(): boolean {
        return this._hideRibbon;
    }
    set hideRibbon(hide: boolean) {
        if (hide != this._hideRibbon) {
            setTimeout(() => this._hideRibbon = hide, 100);
        }
    }

    getEditedimage(image) {
        this.returnImage = image;
        this.genericFlag = true;
    }

    getFullDate(date: string, time: string): Date {
        let dtSplit = date.split('-');
        let tmSpli = time.split(':');
        return new Date(parseInt(dtSplit[0]), parseInt(dtSplit[1]) - 1, parseInt(dtSplit[2]), parseInt(tmSpli[0]),
            parseInt(tmSpli[1]), 0, 0);
    }

    getImageNode(user: User): string {
        let status: string = 'assets/img/statusOffline.png';
        let image: any = 'assets/img/placeholder.jpg';
        if (!isNullOrUndefined(user.imageProfile) && !isNullOrUndefined(user.imageProfile.encodedImageContent)) {
            image = `data:${user.imageProfile.contentType};base64,${user.imageProfile.encodedImageContent}`;
        }
        return image;
    }

}
